import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {Container} from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import {InertiaLink} from "@inertiajs/inertia-react";
import { Trans } from "../utils/i18n";

const BackLink = styled(InertiaLink)`
    text-decoration: none;
    color: ${props => props.theme.text};
`;

const BackSpan = styled.span`
    margin-top: 30px;
    color: ${props => props.theme.secondary};
`;

export default function BackButton({ href, label }) {
    return (
        <BackLink href={href ? href : route('dashboard')}>
            <ArrowBackIcon color={'secondary'} fontSize="small" style={{ verticalAlign: 'bottom' }}/>
            <BackSpan>{ label ? label: <Trans i18nKey="backButton.dashboard">Dashboard</Trans> }</BackSpan>
        </BackLink>
    );
}
